import { useContext, useState, useRef } from "react";
import { useMutation } from "@apollo/client";
import { LOGIN_MUTATION } from "../../graphql/graphql";
import { LoginContext } from "../context/LoginContext";
// import jwt from "jsonwebtoken"

// const SECRET ="ishield-backend-test";

// const verifyToken = async (token) => {
//   const decoded = jwt.verify(token, SECRET);
//   // console.log("verifyToken");
//   // console.log(decoded._doc);
//   return decoded._doc;
// };

const useLogin = () => {
  const { setToken, setUserAuthority, setCluster, setPermissions, setVerified } = useContext(LoginContext);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContent, setConfirmContent] = useState("此帳號目前已在其他裝置登入，是否要擠掉並登入？");
  const lastCredsRef = useRef(null);


  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" })

  const [login, { loading, error }] = useMutation(LOGIN_MUTATION, {
    onCompleted: (data) => {
      // console.log(data.login.user);
      // setAuthToken(data.login.token)
      if (data.login.status === "success") {
        // localStorage.setItem(AUTH_TOKEN, data.login.msg);
        // console.log(verifyToken(data.login.msg))
        // setToken(data.login.msg);
        setToken('cookie');
        setUserAuthority(data.login.user.authority);
        setCluster(data.login.user.cluster);
        sessionStorage.setItem("authority", data.login.user.authority);
        setPermissions(data.login.user.myPermissions ?? []);
        setVerified(data.login.user.verified);
        setSnackbar({ open: true, severity: "success", message: "登入成功" });
        setConfirmOpen(false);
        lastCredsRef.current = null;
        // setIsLogin(true);
      } else if (data.login.status === "conflict") {
        setConfirmContent(data.login.msg || "此帳號目前已在其他裝置登入，是否要擠掉並登入？");
        setConfirmOpen(true);
      } else {
        setToken(null);
        setSnackbar({ open: true, severity: "error", message: data.login.msg || "登入失敗" });
      }
    },
  });

  const doLogin = async (values, force = false) => {
    lastCredsRef.current = values;
    return login({ variables: { ...values, force } });
  };

  const onFinish = async (values) => {
    return doLogin(values, false);
  };

  const onFinishFailed = (errorInfo) => {
    setSnackbar({ open: true, severity: "error", message: "表單驗證失敗，請檢查欄位" });
    console.log("Failed:", errorInfo);
    // updateShow();
  };

  const confirmForceLogin = async () => {
    const creds = lastCredsRef.current;
    if (!creds) {
      setConfirmOpen(false);
      return;
    }
    await doLogin(creds, true);
  };

  const cancelForceLogin = () => {
    setConfirmOpen(false);
    lastCredsRef.current = null;
  };

  const closeSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));

  return {
    onFinish,
    onFinishFailed,
    loading,
    error,
    // MUI UI 狀態/方法
    confirmOpen,
    confirmContent,
    confirmForceLogin,
    cancelForceLogin,
    snackbar,
    closeSnackbar,
  };
};

export { useLogin };
